<template>
  <div class="">
    <loading v-if="loadingRender"></loading>
    <panel
      Title="گزارش درخواست های تسهیلات"
      Des="از طریق این فرم می توانید لیست درخواست های تسهیلات را مشاهده و مدیریت نمایید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <net-pa-card>
            <template slot="header">
              <h6 class="text-right">
                <i class=""></i>لیست درخواست های تسهیلات
              </h6>
            </template>
            <template slot="content">
              <div class="px-3">
                <div class="row border rounded p-2">
                  <div class="col-md-3 col-12 pr-0">
                    <small class="">انتخاب وضعیت درخواست</small>
                    <select class="form-control" v-model="FilterGrp312">
                      <option :value="-1">همه حالت ها</option>
                      <option
                        v-for="(item, key) in Grp312"
                        :key="key"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2 col-12 mt-1">
                    <button
                      class="btn btn-success rounded w-100 mt-3"
                      @click="Serach"
                    >
                      <i class="fa fa-search"></i> جستـــجو
                    </button>
                  </div>
                </div>
              </div>

              <vue-bootstrap4-table
                :rows="rows"
                :columns="columns"
                :config="config"
                :classes="classes"
                :actions="actions"
                @on-download="Download"
                @on-download-pdf="GetPDF"
              >
                <template slot="global-search-clear-icon">
                  <i class="fas fa-times-circle"></i>
                </template>
                <template slot="sort-asc-icon">
                  <i class="fa fa-sort-up"></i>
                </template>
                <template slot="sort-desc-icon">
                  <i class="fa fa-sort-down"></i>
                </template>
                <template slot="no-sort-icon">
                  <i class="fa fa-sort"></i>
                </template>
                <template slot="empty-results">
                  <p class="text-right">اطلاعاتی یافت نشد</p>
                </template>
                <template slot="mablagh" slot-scope="props">
                  <p class="text-center">
                    {{ $Comma3ragham(props.row.mablagh) }}
                  </p>
                </template>
                <template slot="Action" slot-scope="props">
                  <button
                    class="btn btn-outline-secondary btn-sm m-1"
                    type="button"
                    @click="DetailVam(props.row.id)"
                    data-toggle="modal"
                    data-target="#Modal-light"
                  >
                    <span>ضامن ها</span>
                  </button>
                  <button
                    class="btn btn-outline-secondary btn-sm m-1"
                    type="button"
                    @click="DownloadAttachment(props.row.id, null)"
                  >
                    <i class="fas fa-download ml-1"></i
                    ><span> دانـــلود فایل ها </span>
                  </button>
                  <button
                    class="btn btn-outline-secondary btn-sm m-1"
                    type="button"
                    @click="Changestate(props.row)"
                    data-toggle="modal"
                    data-target="#Modal-light"
                  >
                    <span>تغــییر وضعیت</span>
                  </button>
                </template>
              </vue-bootstrap4-table>
            </template>
          </net-pa-card>
        </div>
      </div>
    </div>
    <modal-custom>
      <template v-slot:ContentModalLight>
        <div v-if="ShowZamen == true" class="row text-center px-2">
          <div class="col-12"><h6>اطلاعات ضامنـــین</h6></div>
          <div class="col-4" v-for="(item, key) in ListZamen" :key="key">
            <div class="box my-1 text-center" v-if="item.azaIdZamen != null">
              <div class="text-dark">مشخصات :</div>
              <div>{{ item.nameFamily }}</div>

              <div class="text-dark mt-2">کدملی :</div>
              <div>{{ item.codeMelli }}</div>

              <div class="text-dark mt-2">کد پرسنلی :</div>
              <div>{{ item.perNoe == null ? "ثبت نشده" : item.perNoe }}</div>

              <div class="text-dark mt-2">رمز کسر اقساط :</div>
              <div>
                {{
                  item.tblComboIdNoe10 == 4031
                    ? item.codeKasreAghsatZamenAsli
                    : item.tblComboIdNoe10 == 4032
                    ? item.codeKasreAghsatZamenFari
                    : item.codeKasreAghsatMoaref
                }}
              </div>

              <!-- <div class="text-dark mt-2"> فایل پیوستی : </div>
              <div class="badge badge-secondary px-2 font-weight-normal Pointer" @click="DownloadAttachment(item.wwwtblNeedVamId,181070523)"> دانلود</div> -->
            </div>
            <div
              class="box my-1 text-center"
              v-if="
                item.azaIdZamen == null &&
                item.mobile != null &&
                item.nameFamily != null
              "
            >
              <div class="text-danger">ضامن عضو نمی باشد</div>
              <div class="text-dark">مشخصات :</div>
              <div>{{ item.nameFamily }}</div>

              <div class="text-dark mt-2">کدملی :</div>
              <div>{{ item.codeMelli }}</div>

              <div class="text-dark mt-2">کد پرسنلی :</div>
              <div>{{ item.perNo == null ? "ثبت نشده" : item.perNo }}</div>

              <div class="text-dark mt-2">رمز کسر اقساط :</div>
              <div>
                {{
                  item.tblComboIdNoe10 == 4031
                    ? item.codeKasreAghsatZamenAsli
                    : item.tblComboIdNoe10 == 4032
                    ? item.codeKasreAghsatZamenFari
                    : item.codeKasreAghsatMoaref
                }}
              </div>

              <!-- <div class="text-dark mt-2"> فایل پیوستی : </div>
              <div class="badge badge-secondary px-2 font-weight-normal Pointer" @click="DownloadAttachment(item.wwwtblNeedVamId,181070523)"> دانلود</div> -->
            </div>
          </div>
        </div>
        <div class="row text-center px-2" v-if="ShowState == true">
          <div class="col-12"><h6>تغییر وضعیت درخواست</h6></div>
          <div class="col-12 mt-3">
            <div class="row">
              <div class="col-md-3 col-12"></div>
              <div class="col-md-6 col-12">
                <select class="form-control text-center" v-model="NewGrp312">
                  <option :value="-1" disabled>-- انتخب وضعیت --</option>
                  <option
                    v-for="(item, key) in Grp312"
                    :key="key"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-3 col-12"></div>

              <div class="col-12 mt-3 text-right">
                <small>شرح اصلاحات</small>
                <textarea
                  class="form-control"
                  v-model="Sharh"
                  placeholder="شرح اصــــــلاحات"
                ></textarea>
              </div>
              <div class="col-md-4 col-12"></div>
              <div class="col-md-4 col-12 mt-3">
                <button class="btn btn-success w-100" @click="ChangeGrp312">
                  اعمال تغییرات وضعیت
                </button>
              </div>
              <div class="col-md-4 col-12"></div>
            </div>
          </div>
        </div>
      </template>
    </modal-custom>

    <div class="col-md-2 col-12 mt-3">
      <ExcelExport
        :data="exceltable"
        worksheet-name="Sheet1"
        @success="handleExcelSuccess"
        @error="handleExcelError"
      >
        <button class="btn btn-outline-success d-none">
          <i
            class="fas fa-file-excel btn btn-outline-success Pointer d-none"
            id="DownloadExcel"
          >
            دانلود فایل اکسل
          </i>
        </button>
      </ExcelExport>
    </div>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import ModalCustom from "../Tools/ModalCustom.vue";
import loading from "../Tools/NetPa/Loading.vue";
export default {
  components: { Panel, VueBootstrap4Table, NetPaCard, ModalCustom, loading },
  data() {
    return {
      loadingRender: false,
      exceltable: [],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: false,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm mt-3",
      },
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "نام و نام خانوادگی ",
          name: "fullName",
        },
        {
          label: "کد ملی",
          name: "codeMeli",
        },
        {
          label: "شماره پرسنلی",
          name: "perNo",
        },
        {
          label: "کد رهگیری",
          name: "codeRahgiri",
        },
        {
          label: "نوع تسهیلات ",
          name: "desNoe",
        },
        {
          label: "تاریخ درخواست",
          name: "requestTarix",
        },
        {
          label: "مبلغ درخواست",
          name: "mablagh",
        },
        {
          label: "تعداد اقساط",
          name: "tedadGhest",
        },
        {
          label: "کسر اقساط",
          name: "ramzKasrAghsat",
        },
        {
          label: "وضعیت",
          name: "stateVam",
        },
        {
          label: "شماره حساب (رفاه)",
          name: "hesabNo",
        },
        {
          label: "مدت سپرده",
          name: "sepordeTime",
        },
        {
          label: "عملیات",
          name: "Action",
        },
      ],
      actions: [
        {
          btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
          event_name: "on-download",
          class: "btn  mx-2 btn-outline-success rounded btnEXL ",
          event_payload: {
            msg: "my custom msg",
          },
        },
      ],
      rows: [],
      Grp312: [],
      FilterGrp312: -1,
      ListZamen: [],
      ShowZamen: false,
      ShowState: false,
      NewGrp312: -1,
      Sharh: "",
      SelectedVam: null,
    };
  },
  methods: {
    Serach() {
      let DataAxios_cmbGrp312 = {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListVamRequests",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("tblComboIdVaziyatGrp312", this.FilterGrp312);
      DataAxios_cmbGrp312.ArryfildValue = formData;
      this.loadingRender = true;
      this.$PostFormData(DataAxios_cmbGrp312).then((res) => {
        this.loadingRender = false;
        // console.log("🤦🏻‍♂️ ~ file: ListVamRequests.vue:231 ~ res:", res)
        if (res.status == "Not Ok") {
          this.$mySweetDefaultTost(
            "جستجـــو ناموفق",
            "اطلاعاتی با فیلتر شما پیدا نشد",
            "warning",
            1000,
          );
          this.rows = [];
          return;
        } else {
          if (res.result.length > 10) {
            this.config.pagination = true;
          } else {
            this.config.pagination = false;
          }
          this.rows = res.result;
          this.exelReport(this.rows);
        }
      });
    },
    GetGrp312() {
      let DataAxios_cmbGrp312 = {
        ArryfildValue: "",
        Method: "Post",
        Action: "SelCombo",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("GrpId", 312);
      DataAxios_cmbGrp312.ArryfildValue = formData;
      this.$PostFormData(DataAxios_cmbGrp312).then((res) => {
        this.Grp312 = res;
      });
    },
    DetailVam(id) {
      let DataAxios = {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListVamRequests/GetDetailZamen",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("VamId", id);
      DataAxios.ArryfildValue = formData;
      this.$PostFormData(DataAxios).then((res) => {
        this.ListZamen = res;
        this.ShowState = false;
        this.ShowZamen = true;
      });
    },
    DownloadAttachment(id, GRP328) {
      var dataAxios = {
        Method: "POST",
        Action: "Uploader/GetFile",
        ArryfildValue: {
          MasterId: id,
          tableName: "wwwtblNeedVam",
          grp328: GRP328,
        },
      };
      this.$PostData(dataAxios).then((res) => {
        if (res.status == "success") {
          res.data.forEach((img) => {
            var fileLink = document.createElement("a");
            fileLink.download = img.filename;
            fileLink.href =
              "data:application/octet-stream;base64," + img.binary;
            document.body.appendChild(fileLink);
            fileLink.target = "_blank";
            fileLink.click();
          });
        }
        if (res.status == "not success") {
          this.$mySweetDefaultTost(
            "جستجـــو ناموفق",
            "فایل پیوستی برای درخواست انتخابی یافت نشد",
            "warning",
            2000,
          );
        }
      });
    },
    Changestate(row) {
      this.SelectedVam = row.id;
      this.ShowZamen = false;
      this.ShowState = true;
    },
    ChangeGrp312() {
      if (this.NewGrp312 == -1) {
        this.$mySweetDefaultTost(
          "عدم انتخاب وضعیت",
          "لطفا یکی از وضعیت ها را انتخاب نمایید",
          "warning",
          3000,
        );
        return;
      }
      let DataAxios = {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListVamRequests/ChangeCombo312",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("ComboId", this.NewGrp312);
      formData.append("VamId", this.SelectedVam);
      formData.append("Sharh", this.Sharh);
      DataAxios.ArryfildValue = formData;
      this.$PostFormData(DataAxios).then((res) => {
        // console.log('😎 ~ this.$PostFormData ~ res:', res)
        if (res.status == "Ok") {
          this.Serach();
          this.ShowZamen = false;
          this.ShowState = false;
          var genericModalEl = document.getElementById("BtnCloseModal");
          genericModalEl.click();
        }
      });
    },
    Download() {
      document.getElementById("DownloadExcel").click();
    },
    exelReport(rows) {
      // console.log('Reeeeeeeeport', rows);
      this.exceltable = [];
      rows.forEach((element) => {
        var excelrow = {
          "نام و نام خانوادگی": element.fullName,
          "کد ملی":  "\"" + element.codeMeli.trim() + "\"",
          "شماره پرسنلی": element.perNo,
          "کد رهگیری": element.codeRahgiri,
          "نوع تسهیلات": element.desNoe,
          "تاریخ درخواست": element.requestTarix,
          "مبلغ درخواست": element.mablagh,
          "تعداد اقساط": element.tedadGhest,
          "کسر اقساط": element.ramzKasrAghsat,
          وضعیت: element.stateVam,
          "شماره حساب رفاه": element.hesabNo,
          "مدت سپرده": element.sepordeTime,
        };

        this.exceltable.push(excelrow);
      });
      // console.log( this.exceltable);
    },
  },
  created() {
    this.GetGrp312();
  },
};
</script>
<style scoped>
.box {
  border-radius: 8px;
  background: #c9d8d5;
  border: none;
  height: auto;
}
</style>
